import React from "react";
import placementImage from "./assets/placement.png";
import stock from "./assets/stockmarket (1).png";
import ieee from "./assets/ieee.jpeg";
import docs from "./assets/googledocs.png";
import website from "./assets/trfwebsite.png";
import github from "./assets/github.png";
import "./project.css";
import { FaEye } from "react-icons/fa6";
export default function Projects() {
  return (
    <section>
      <div className="project-list">
        <div className="project-item.active">
          <a
            href="https://trf-placement-website.netlify.app/"
            className="custom-link"
          >
            <div className="project-container">
            <FaEye 
                className="eye-icon"
                style={{ color: "hsl(45, 100%, 72%)", width: 20, height: 20 }}
              />
              <img src={placementImage} alt="Logo" className="imagew" />
              <h3 className="project-text">CrackIt</h3>
              <p className="project-category">Machine Learning</p>
            </div>
          </a>
        </div>
        <div className="project-item.active">
          <a
            href="https://ieeexplore.ieee.org/document/9741028"
            className="custom-link"
          >
            <div className="project-container">
            <FaEye 
                className="eye-icon"
                style={{ color: "hsl(45, 100%, 72%)", width: 20, height: 20 }}
              />
              <img src={ieee} alt="Logo" className="imagew" />
              <h3 className="project-text">Hindi Sentimental Analysis</h3>
              <p className="project-category">Machine Learning</p>
            </div>
          </a>
        </div>
        <div className="project-item.active">
          <a href="https://price-of-stock.netlify.app/" className="custom-link">
            <div className="project-container">
            <FaEye 
                className="eye-icon"
                style={{ color: "hsl(45, 100%, 72%)", width: 20, height: 20 }}
              />
              <img src={stock} alt="Logo" />
              <h3 className="project-text">Stock Market Website</h3>
              <p className="project-category">Machine Learning</p>
            </div>
          </a>
        </div>
        <div className="project-item.active">
          <a
            href="https://google-docs-clone-08.netlify.app/"
            className="custom-link"
          >
            <div className="project-container">
            <FaEye 
                className="eye-icon"
                style={{ color: "hsl(45, 100%, 72%)", width: 20, height: 20 }}
              />
              <img src={docs} alt="Logo" />
              <h3 className="project-text">Google Docs Clone</h3>
              <p className="project-category">Machine Learning</p>
            </div>
          </a>
        </div>
        <div className="project-item.active">
          <a
            href="https://thunderous-druid-242e7f.netlify.app/"
            className="custom-link"
          >
            <div className="project-container">
            <FaEye 
                className="eye-icon"
                style={{ color: "hsl(45, 100%, 72%)", width: 20, height: 20 }}
              />
              <img src={website} alt="Logo" />
              <h3 className="project-text">TRF Club Website</h3>
              <p className="project-category">Machine Learning</p>
            </div>
          </a>
        </div>
        <div className="project-item.active">
          <a
            href="https://github.com/radhathakare?tab=repositories"
            className="custom-link"
          >
            <div className="project-container">
            <FaEye 
                className="eye-icon"
                style={{ color: "hsl(45, 100%, 72%)", width: 20, height: 20 }}
              />
              <img src={github} alt="Logo" />
              <h3 className="project-text">Other Projects on Github</h3>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
